import DocusignUrl from './DocusignUrl.page';

export default DocusignUrl;
